import { Box, Typography } from "@mui/material";

import { AppointmentExchangeResponse } from "@/api";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { useAppointmentLabels } from "@/common/hooks/useAppointmentLabels";
import { formatExchangeAppointment } from "@/pages/exchange/Exchange.utils";
import { joinRequestedPurposeLabels } from "@/pages/exchange/components/exchange-table/ExchangeTable.utils";
import { useTranslation } from "@/translations";

interface Props {
  exchange: AppointmentExchangeResponse;
}

/** The header line of the overlay: the own Dienst that is up for swap and what is wanted in return. */
export function ExchangeRequestSummary({ exchange }: Props) {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const labels = useAppointmentLabels();

  const ownService = [
    formatExchangeAppointment(exchange, locales[language], t),
    labels.purposeLabelOf(exchange.purposeKey),
    exchange.location ?? null,
  ]
    .filter((part): part is string => part !== null)
    .join(" · ");

  return (
    <Box display="flex" alignItems="baseline" flexWrap="wrap" gap={0.75}>
      <Typography variant="body2" color="text.secondary">
        {t("exchange.offersDialog.ownService")}
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        {ownService}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {`— ${t("exchange.offersDialog.requested", {
          requested: joinRequestedPurposeLabels(exchange.requestedPurposeKeys, labels, t),
        })}`}
      </Typography>
    </Box>
  );
}
